import React, { FC, memo, useState } from "react";
import { styled } from "@mui/material/styles";
import { CardActions, CardContent, Collapse } from "@mui/material";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { useHistory } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import ReactCountryFlag from "react-country-flag";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { Card } from "components/Shared/Card";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { useAppDispatch } from "redux/store/hooks";
import { addFavouriteExpert } from "redux/actions/expertsList";
import RoutePaths from "routes/RoutePaths";
import { getLessonById } from "redux/actions/lessons";
import { setSelectedLesson } from "redux/reducers/lessonsSlice";
import LessonInfoPopup from "./LessonInfoPopup";
import { LessonMode } from "features/lessons/models";
import { useAuthSelectors } from "redux/selectors";
import LessonContent from "./lessonContent";
import {
  ICountryExpertLessonPack,
  ICountryExpertLessonSingle,
} from "../../../types/components/expertCountry";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

interface IExpertCard {
  expert: any;
  country: any;
}

const ExpandMoreComponent = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ExpertCard: FC<IExpertCard> = ({ expert, country }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [expanded, setExpanded] = useState<boolean>(false);
  const { push } = useHistory();
  const [isLessonInfoModalOpen, setIsLessonInfoModalOpen] =
    useState<boolean>(false);
  const [selectedLessonType, setSelectedLessonType] = useState<any>();
  const [isFavorite, setIsFavorite] = useState<boolean>(expert?.is_favorite);
  const { selectAuthUser } = useAuthSelectors();

  const handleExpandClick = () => {
    setExpanded((prev) => !prev);
  };

  const isFavoriteHandler = () => {
    setIsFavorite((prev) => !prev);
    let data = {
      expert_id: expert.id,
    };
    dispatch(addFavouriteExpert(data));
  };

  const showInfoHandler = (lesson: any, lessonTypeString: string) => {
    dispatch(setSelectedLesson(null));
    const data = {
      lesson_id: lesson.id,
      type: lessonTypeString,
    };
    setSelectedLessonType(lessonTypeString);
    dispatch(getLessonById(data));
    setIsLessonInfoModalOpen(true);
  };

  return (
    <div className="expert">
      <Card>
        <CardContent className="card_content">
          <img
            src={expert?.avatar}
            referrerPolicy="no-referrer"
            alt="pro pic"
            className="avatar"
            onClick={() => push(`${RoutePaths.selectedExpert}?id=${expert.id}`)}
          />
          <div className="right">
            <div className="name_area">
              <span className="name">{`${expert?.name}`}</span>
              {selectAuthUser?.logged && (
                <IconButton onClick={isFavoriteHandler}>
                  {isFavorite ? (
                    <FaHeart className="like" />
                  ) : (
                    <FaRegHeart className="unlike" />
                  )}
                </IconButton>
              )}
            </div>
            <div className="country_area">
              <div className="country">
                <ReactCountryFlag countryCode={country?.code} svg />
                <span>{t("countries." + country?.name)}</span>
              </div>
            </div>
            <div className="lang">
              {expert?.lanuages?.map((language: any, index: number) => (
                <span key={index}>{language?.name}</span>
              ))}
            </div>
          </div>
        </CardContent>
        <CardActions
          disableSpacing
          className="col_exp_btn"
          onClick={handleExpandClick}
        >
          <div className="center">
            <span>
              {expanded
                ? t("home.famousExperts.ExpertCard.showLess")
                : t("home.famousExperts.ExpertCard.showMore")}
            </span>
            <ExpandMoreComponent
              expand={expanded}
              // onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMore />
            </ExpandMoreComponent>
          </div>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent className="expand_content">
            {expert?.lesson.map(
              (
                item: ICountryExpertLessonSingle | ICountryExpertLessonPack,
                i: number
              ) =>
                "lesson" in item && item.lesson && item.topic ? (
                  <LessonContent
                    key={i}
                    lesson={{ ...item.lesson, topic: item.topic }}
                    onClickHandler={() =>
                      showInfoHandler(item?.lesson, LessonMode.PACK)
                    }
                  />
                ) : (
                  <LessonContent
                    key={i}
                    // @ts-ignore
                    lesson={item}
                    onClickHandler={() =>
                      showInfoHandler(item, LessonMode.SINGLE)
                    }
                  />
                )
            )}
          </CardContent>
        </Collapse>
      </Card>
      {/* {isLessonInfoModalOpen && modal} */}
      {isLessonInfoModalOpen && (
        <LessonInfoPopup
          selectedLessonType={selectedLessonType}
          isLessonInfoModalOpen={isLessonInfoModalOpen}
          onCloseHandler={() => {
            setIsLessonInfoModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default memo(ExpertCard);
